import React, { Component } from 'react'

class CategoryItem extends Component {
    render() {
        const { isSelected } = this.props
        const cat = this.props.category

        return (
            <div className={'selection' + (isSelected ? ' selected' : '') + (cat.selected ? ' active' : '')}
                onClick={() => this.props.handleCategoryClick(cat)}
            >
                <div className="txt">{cat.title}</div>
                <span className="icon-star-full"></span>
            </div>
        )
    }
}

export default CategoryItem



// WEBPACK FOOTER //
// ./src/components/admin/products/category-search/CategoryItem.js